// Utility to resolve the best avatar URL for a user-like object
// - Tries multiple common property names
// - Prefixes relative upload paths (e.g., /uploads/...) with REACT_APP_API_BASE_URL
// - Returns undefined if nothing usable is found

export function getAvatarUrl(user) {
  try {
    if (!user) return undefined;

    // Use provided rule: prefer avatarUrl; if it begins with /uploads, prefix with API_ORIGIN
    const API_ORIGIN = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/+$/, '').replace(/\/api$/, '');
    const raw = user && user.avatarUrl ? String(user.avatarUrl) : undefined;

    let url = raw;

    // Fall back to other common fields if avatarUrl missing
    if (!url) {
      const candidates = [
        user.avatar,
        user.photoURL,
        user.profilePic,
        user.imageUrl,
        user.picture,
        user.image,
        Array.isArray(user.photos) && user.photos.length ? user.photos[0]?.url : undefined,
      ].filter(Boolean);
      url = candidates.length ? String(candidates[0]) : undefined;
    }

    if (!url) return undefined;

    // If relative upload path
    if (url.startsWith('/uploads')) {
      return `${API_ORIGIN}${url}`;
    }

    // Already absolute (http, https, data, blob) or starts with /
    if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:') || url.startsWith('blob:')) {
      if (url.startsWith('//') && typeof window !== 'undefined' && window.location?.protocol) {
        return `${window.location.protocol}${url}`;
      }
      return url;
    }

    // Other leading slash paths: prefix with API_ORIGIN if available
    if (url.startsWith('/')) {
      return API_ORIGIN ? `${API_ORIGIN}${url}` : url;
    }

    // Host:port without protocol
    if (/^[\w.-]+:\d+\//.test(url)) {
      return `http://${url}`;
    }

    return url;
  } catch (_) {
    return undefined;
  }
}

export function getFunnyAvatarUrl(user) {
  const seed = encodeURIComponent(user?.username || user?.email || user?.name || 'User');
  return `https://api.dicebear.com/7.x/avataaars/svg?seed=${seed}&size=160&radius=50`;
}

export function getAvatarOrFunny(user) {
  const u = getAvatarUrl(user);
  return u || getFunnyAvatarUrl(user);
}
